import { ButtonV2 } from "src/components/ButtonV2/ButtonV2.tsx";
import { TextArea } from "src/components/TextArea/TextArea.tsx";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { ModalV3 } from "src/components/ModalV3/ModalV3.tsx";

type Props = {
  onSave(selectedItems: string): void;
  onCancel(): void;
  onClose(): void;
  content: string;
  onContentChange: (value: string) => void;
  isSaving: boolean;
};

export function CreateCommentModal(props: Props) {
  const { onSave, onCancel, onClose, content, onContentChange, isSaving } =
    props;
  const { t } = useTranslation(TranslationNamespaceEnum.CommentsFormPanel);

  return (
    <ModalV3 onClose={onClose}>
      <ModalV3.Positioner>
        <ModalV3.Content>
          <ModalV3.CloseTrigger />
          <ModalV3.Header>
            <ModalV3.Title>{t("modal.title")}</ModalV3.Title>
          </ModalV3.Header>
          <ModalV3.Body
            style={{
              width: 550,
            }}
          >
            <TextArea
              value={content}
              onChange={(e) => onContentChange(e.currentTarget.value)}
              label={t("modal.form.content.label")}
              maxLength={500}
            />
          </ModalV3.Body>
          <ModalV3.Footer>
            <ModalV3.FooterButtons>
              <ButtonV2 skin="info" variant="outlined" onClick={onCancel}>
                {t("actions.cancel", {
                  ns: TranslationNamespaceEnum.Common,
                })}
              </ButtonV2>
              <ButtonV2
                startAdornment={<span className={"icon-15-save"} />}
                skin="info"
                isPending={isSaving}
                variant="filled"
                onClick={() => onSave(content)}
              >
                {t("actions.save", {
                  ns: TranslationNamespaceEnum.Common,
                })}
              </ButtonV2>
            </ModalV3.FooterButtons>
          </ModalV3.Footer>
        </ModalV3.Content>
      </ModalV3.Positioner>
    </ModalV3>
  );
}
